export default __webpack_public_path__ + "static/media/multi_race_people_image.856991f2.png";